import React, { FC } from 'react';
import { MetricContext } from '@src/metrics/metrics.enum';
import AddPaymentMethod from '@src/containers/AddPaymentMethod';
import InvoiceDetails from '@src/containers/InvoiceDetails';
import { CreditCardsProps } from './props';
import './styles.scss';

export const CreditCards: FC<CreditCardsProps> = ({
  isInvoiceFormVisible,
  isPayByInvoiceEnabled,
  selectedPlanPrice,
  symbol,
  onPaymentMethodAdded,
  closeModal,
  onCompleted,
  recruiterName,
  onChangePlan,
}) => {
  return (
    <div className="activate-subscription-credit-cards">
      <div className="activate-subscription-credit-cards__container">
        <div className="activate-subscription-credit-cards__header">
          <h5>Welcome to MeetFrank, {recruiterName}!</h5>
          <h2>Subscribe for full access</h2>
          <p>
            You selected Started plan, for {selectedPlanPrice}
            {symbol} month.{' '}
            <span className="activate-subscription-credit-cards__change-plan" onClick={onChangePlan}>
              Change plan
            </span>
            .
          </p>
        </div>
        <div className="activate-subscription-credit-cards__card-details-container">
          {!isInvoiceFormVisible ? (
            <AddPaymentMethod
              buttonLabel="Subscribe"
              className="activate-subscription-modal-right__payment"
              disableInvoicing={!isPayByInvoiceEnabled}
              metricsContext={MetricContext.ACTIVATE_SUBSCRIPTION}
              onPaymentMethodAdded={onPaymentMethodAdded}
            />
          ) : (
            <div className="activate-subscription-modal-right__invoice-wrapper">
              <h4 className="activate-subscription-modal-right__invoice-form-title">
                Please fill in your invoicing details
              </h4>
              <InvoiceDetails
                buttonLabel={'Confirm'}
                onUpdated={() => {
                  closeModal();
                  onCompleted();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
